<template>
  <div>
    <h1 class="text-center mb-3">Utvidet info</h1>
    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-cash</v-icon>
            </v-toolbar-side-icon>

            <v-toolbar-title>Årlige utgifter</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pr-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Kommunale avgifter per år"
                    type="number"
                    v-model="stepValues.communal"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pl-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Eiendomsskatt per år"
                    type="number"
                    v-model="stepValues.tax"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pr-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Forsikringspremie per år"
                    type="number"
                    v-model="stepValues.insurance"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pl-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Festeavgift per år"
                    type="number"
                    v-model="stepValues.feste"
                    suffix="NOK"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-4">
        <v-card>
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-power-socket-eu</v-icon>
            </v-toolbar-side-icon>

            <v-toolbar-title>Strøm</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pr-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Strømmålernummer"
                    type="number"
                    v-model="stepValues.powermeter"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pl-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Målepunkt-id"
                    type="number"
                    v-model="stepValues.powerid"
                    
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pr-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Årlig strømforbruk"
                    type="number"
                    v-model="stepValues.kwh"
                    suffix="kWh"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="pl-sm-2 mt-2">
                <v-card>
                  <v-text-field
                    box
                    hide-details
                    label="Annen oppvarming"
                    type="number"
                    suffix="NOK"
                    v-model="stepValues.other_power"
                    @input="updateFields"
                  ></v-text-field>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-4">
        <v-card>
          <v-textarea
            box
            label="Andre notater"
            v-model="stepValues.notes"
            @input="updateFields"
          ></v-textarea>
        </v-card>
      </v-flex>      
    </v-layout>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step]
};
</script>
